import {
  everyQuestionHas,
  registerInteraction,
} from "@/components/OliverBotV2/interactions/registry";
import UserSelectionCard from "./UserSelectionCard.vue";

registerInteraction("user_selection", {
  component: UserSelectionCard,
  accepts: (card) => everyQuestionHas(card, "people"),
});
